import classes from "./BoxesContainer.module.css";
import { MuuriComponent } from "muuri-react";
import "./BoxesContainer.css";
import Box from "../../../TEMPLATE/components/box/Box";
// import { UvUrl } from "../../hardCodeData/DATA";
import Meteor from "../../../TEMPLATE/components/categories/meteo/Meteor";
import Meshlium from "../../../TEMPLATE/components/categories/meshlium/Meshlium";
import UvIndexes from "../../../TEMPLATE/components/categories/uv/UvIndexes";
import Weather from "../../../TEMPLATE/components/categories/weather/Weather";
import CustomCategoryUniversity from "../categories/CustomCategoryUniversity";
// import LanguageContext from "../../../TEMPLATE/hooks/language-context";
import MapPOIS from "../../../TEMPLATE/components/categories/mapPOIS/MapPOIS";
// import CustomCategoryDiav from "../categories/CustomCategoryDiav";
// import Applicants from "../categories/Applicants";
// import IanosEnergy from "../categories/IanosEnergy";
import Parking from "../categories/Parking";
// import MapPOISAMEA from "../../../TEMPLATE/components/categories/MapPOISAMEA/MapPOISAMEA";
import WelcomeMessage from "../../../TEMPLATE/components/Home/Welcome/WelcomeMessage";
import styled from "styled-components";
// import ThreeDimensions from "../categories/ThreeDimensions";
// import Mapping from "../categories/Mapping";
// import Publics from "../categories/Publics";
// import Hum from "../categories/Hum";
import { useAllContexts } from "../../../TEMPLATE/hooks/useAllContexts";
// import Power from "../categories/Power";
import { useTranslation } from "react-i18next";
// import Clock from "../../../TEMPLATE/components/categories/clock/Clock";

import Advertisement from "../categories/Advertisement";
import { advertisements } from "../../hardCodeData/DATA";
import Parking1 from "../categories/Parking1";

const maxEntitiesLargeBox = 9;
const maxEntitiesMediumBox = 2;

const options = {
  dragSortHeuristics: {
    sortInterval: 0,
  },
  layoutDuration: 400,
  dragRelease: {
    duration: 400,
    easing: "ease-out",
  },
  dragEnabled: true,
  dragStartPredicate: function (item, hammerEvent) {
    if (hammerEvent.target.matches("#draggable")) {
      return true;
    }
    return false;
    // distance: 0,
    // delay: 500,
  },
  dragContainer: document.body,
  // The placeholder of an item that is being dragged.
  dragPlaceholder: {
    enabled: true,
    createElement: function (item) {
      // The element will have the Css class ".muuri-item-placeholder".
      return item.getElement().cloneNode(true);
    },
  },
};
const BoxesContainer = () => {
  const { hum } = useAllContexts();
  const { t } = useTranslation();
  return (
    <BoxesWrapper>
      <WelcomeWrapper>
        <WelcomeMessage />
      </WelcomeWrapper>
      <MuuriComponent {...options}>
        <Box className={classes.large} typeId="1">
          <Meteor
            typeId="1"
            title={t("environmental.title")}
            showSubTitle={true}
            type={"environmental"}
          />
        </Box>

        {/* <Box className={classes.large} typeId="6">
          <Meteor
            maxEntities={maxEntitiesLargeBox}
            typeId="6"
            title={t("hydro.title")}
            showSubTitle={true}
            type={"hydro"}
          />
        </Box> */}

        <Box className={classes.large} typeId="5">
          <Meteor
            typeId="5"
            title={t("meteo")}
            showSubTitle={true}
            type={"meteos"}
          />
        </Box>
        {/* <Box className={classes.large} typeId="1">
          <Meteor
            typeId="1"
            title={t("environmental.title")}
            showSubTitle={true}
            group="2"
            type={"environmental"}
          />
        </Box> */}

        <Box className={classes.map_box} typeId="9">
          <MapPOIS typeId="9" title={t("bins.title")} />
        </Box>

        <Box className={classes.map_box} typeId="4">
          <MapPOIS typeId="4" title={t("wifi.title")} />
        </Box>
        {/* <Box className={classes.map_box} typeId="32">
          <MapPOIS typeId="32" title={t("crossings.title")} />
        </Box>
        <Box className={classes.map_box} typeId="30">
          <MapPOIS typeId="30" title={t("benches.title")} />
        </Box>
        <Box className={classes.map_box} typeId="31">
          <MapPOIS typeId="31" title={t("chargers.title")} />
        </Box> */}

        {/* <Box className={classes.medium} typeId="2">
          <Meshlium
            maxEntities={maxEntitiesMediumBox}
            previewIndex={0}
            typeId="2"
            type="mesh"
          />
        </Box> */}

        {/* <Box className={classes.medium} typeId="1">
          <Meteor
            typeId="1"
            title={t("environmental.title")}
            showSubTitle={true}
            group="3"
          />
        </Box> */}

        {/* <Box className={classes.medium} typeId="2">
          <Meshlium
            maxEntities={maxEntitiesMediumBox}
            previewIndex={1}
            typeId="2"
            type="mesh"
          />
        </Box> */}

        {/* UV METRICS */}

        <Box
          className={[classes.medium, classes.uv_style].join(" ")}
          typeId="5"
        >
          <UvIndexes
            title={t("uv.title")}
            indexName="ΔΕΙΚΤΗΣ UV"
            typeId="5"
            indexType="uv"
          />
        </Box>

        <Box
          className={[classes.medium, classes.uv_style].join(" ")}
          typeId="5"
        >
          <UvIndexes
            title={t("discomfort.title")}
            indexName="ΔΕΙΚΤΗΣ ΔΥΣΦΟΡΙΑΣ"
            typeId="5"
            indexType="discomfort"
          />
        </Box>

        <Box
          className={[classes.medium, classes.uv_style].join(" ")}
          typeId="5"
        >
          <UvIndexes
            title={t("humidity.title")}
            indexName="ΔΕΙΚΤΗΣ ΥΓΡΑΣΙΑΣ"
            typeId="5"
            indexType="humidity"
          />
        </Box>

        <Box
          className={[classes.medium, classes.uv_style].join(" ")}
          typeId="5"
        >
          <UvIndexes
            title={t("air_quality.title")}
            indexName="ΠΟΙΟΤΗΤΑ ΑΕΡΑ"
            typeId="5"
            indexType="air_quality"
          />
        </Box>

        <Box className={[classes.medium, classes.weatherBox].join(" ")}>
          <Weather />
        </Box>

        <Box
          className={`${classes.medium} ${classes.parking}`}
          title={"Παρκινγ"}
        >
          <Parking1 id={0} typeId={"24"} place={"0"} />
        </Box>

        <Box
          className={`${classes.medium} ${classes.parking}`}
          title={"Παρκινγ"}
        >
          <Parking1 id={0} typeId={"24"} place={"1"} />
        </Box>

        <Box
          className={`${classes.medium} ${classes.parking}`}
          title={"Παρκινγ"}
        >
          <Parking1 id={0} typeId={"24"} place={"2"} />
        </Box>
        <Box
          className={`${classes.medium} ${classes.parking}`}
          title={"Παρκινγ"}
        >
          <Parking1 id={0} typeId={"24"} place={"3"} />
        </Box>
        <Box
          className={`${classes.medium} ${classes.parking}`}
          title={"Παρκινγ"}
        >
          <Parking1 id={0} typeId={"24"} place={"4"} />
        </Box>
        <Box
          className={`${classes.medium} ${classes.parking}`}
          title={"Παρκινγ"}
        >
          <Parking1 id={0} typeId={"24"} place={"5"} />
        </Box>
        

        <Box className={`${classes.medium} ${classes.advertisement_v1}`}>
          <Advertisement
            title={advertisements[0].title}
            external={advertisements[0].externalLink}
            img={advertisements[0].img}
          />
        </Box>

        <Box className={`${classes.medium} ${classes.advertisement_v2}`}>
          <Advertisement
            title={advertisements[1].title}
            external={advertisements[1].externalLink}
            img={advertisements[1].img}
          />
        </Box>
        <Box className={`${classes.medium} ${classes.advertisement_v3}`}>
          <Advertisement
            title={advertisements[2].title}
            external={advertisements[2].externalLink}
            img={advertisements[2].img}
          />
        </Box>
        <Box className={`${classes.medium} ${classes.advertisement_v4}`}>
          <Advertisement
            title={advertisements[3].title}
            external={advertisements[3].externalLink}
            img={advertisements[3].img}
          />
        </Box>
        <Box className={`${classes.medium} ${classes.advertisement_v5}`}>
          <Advertisement
            title={advertisements[4].title}
            external={advertisements[4].externalLink}
            img={advertisements[4].img}
          />
        </Box>
      </MuuriComponent>
    </BoxesWrapper>
  );
};

export default BoxesContainer;

const BoxesWrapper = styled.div`
  width: 100%;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  margin: 0 auto;

  @media only screen and (max-width: 908px) {
    width: unset;
    display: block;
  }

  scrollbar-color: #373b40 #1a1d21;
  scrollbar-width: thin;
`;

const WelcomeWrapper = styled.div`
  display: none;

  @media only screen and (max-width: 908px) {
    display: block;
  }
`;
